import { createApp } from 'vue';
import config from '@/config.json';
import datefns from '@/modules/date';
import cache from '@/modules/cache';
import { auth, api, http } from '@/modules/auth';
import { Components, Directives, createBootstrap } from 'bootstrap-vue-next';
import { bvModal, bvToast } from '@/modules/bootstrapCompat';
import store from '@/modules/store';
import util from '@/modules/util';
import router from '@/router';
import App from '@/App.vue';
import BFormDatepickerCompat from '@/components/BFormDatepickerCompat.vue';
import '@/brand.scss';

const app = createApp(App);

app.use(createBootstrap());

app.component('BFormDatepicker', BFormDatepickerCompat);

Object.entries(Components).forEach(([name, component]) => {
  app.component(name, component);
});

Object.entries(Directives).forEach(([name, directive]) => {
  const directivename = name
    .replace(/^v/, '')
    .replace(/^B/, 'b')
    .replace(/([A-Z])/g, '-$1')
    .replace(/^-/, '')
    .toLowerCase();
  app.directive(directivename, directive);
});

app.config.globalProperties.$config = config;
app.config.globalProperties.$cache = cache;
app.config.globalProperties.$http = http;
app.config.globalProperties.$api = api;
app.config.globalProperties.$auth = auth;
app.config.globalProperties.$datefns = datefns;
app.config.globalProperties.$util = util;
app.config.globalProperties.$bvModal = bvModal;
app.config.globalProperties.$bvToast = bvToast;

app.config.errorHandler = (err, vm, info) => {
  if (err?.type) {
    api.post('/error', err);
  } else {
    const baseURI = vm?.$el?.baseURI || window?.location?.href || 'unknown';
    api.post('/error', { type: 'crash', error: `${baseURI} - ${info} - ${String(err)}` });
  }
};

app.use(router);
app.use(store);

app.mount('#app');
